import { render, staticRenderFns } from "./MobileIntroduce.vue?vue&type=template&id=08efd70a&scoped=true&"
import script from "./MobileIntroduce.vue?vue&type=script&lang=js&"
export * from "./MobileIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./MobileIntroduce.vue?vue&type=style&index=0&id=08efd70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efd70a",
  null
  
)

export default component.exports